export default "__VITE_ASSET__731c536c__"